
import { isAppUsing } from '@@/bits/flip'
import { Comment, Id } from '@@/types'
import { Component, namespace, Prop, Vue } from 'bits/vue'
import OzIcon from 'library/v4/components/OzIcon.vue'
import emitClickOnTouch from 'vuedirectives/emit_click_on_touch'

@Component({
  components: {
    OzIcon,
  },
  directives: {
    emitClickOnTouch,
  },
})
export default class SurfacePostCommentsIcon extends Vue {
  @Prop() commentIds!: [string | number]
  @Prop() colorScheme!: 'light' | 'dark'
  @Prop() disable!: boolean
  @Prop({ default: 'postView' }) usageContext!: 'postView' | 'postExpandedView'

  @namespace('browser').Getter isSmallerThanTabletPortrait!: boolean
  @namespace('comment').State commentEntities!: { [id: Id]: Comment }

  get isUsedInPostExpandedView(): boolean {
    return this.usageContext === 'postExpandedView'
  }

  get iconSize(): number {
    if (this.isUsedInPostExpandedView) {
      return this.isSmallerThanTabletPortrait ? 24 : 20
    }
    return 18
  }

  get commentsListLength(): number {
    if (isAppUsing('commentModeration')) {
      const publishedCommentIds = this.commentIds.filter(
        (id) => !this.commentEntities[id as number].is_awaiting_approval,
      )
      return publishedCommentIds.length
    }
    return this.commentIds.length
  }

  showCommentsPanel(): void {
    if (this.disable) return
    if (this.$el.closest('.surface-post')?.classList.contains('noclick')) {
      // Prevent popping out the comment panel when the post is being dragged
      return
    }
    this.$emit('show-comments-panel')
  }
}
